import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface TestimonialProps {
  quote: string;
  name: string;
  role: string;
  emoji: string;
  index: number;
}
function TestimonialCard({
  quote,
  name,
  role,
  emoji,
  index
}: TestimonialProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.div ref={ref} className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg border border-rose-100" initial={{
    opacity: 0,
    y: 30
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5,
    delay: index * 0.15
  }} data-id="element-192">
      <div className="text-3xl mb-4" data-id="element-193">{emoji}</div>
      <div className="flex gap-1 mb-4" data-id="element-194">
        {[...Array(5)].map((_, i) => <span key={i} className="text-amber-400 text-lg" data-id="element-195">
            ★
          </span>)}
      </div>
      <p className="text-slate-700 leading-relaxed mb-6 text-lg italic" data-id="element-196">
        "{quote}"
      </p>
      <div className="border-t border-rose-50 pt-4" data-id="element-197">
        <p className="font-bold text-slate-900" data-id="element-198">{name}</p>
        <p className="text-sm text-slate-500" data-id="element-199">{role}</p>
      </div>
    </motion.div>;
}
export function TestimonialsSection() {
  const headerRef = useRef(null);
  const isHeaderInView = useInView(headerRef, {
    once: true
  });
  const testimonials = [{
    quote: 'Perfecto para decorar el cumpleaños de mi hija. Súper fácil de usar, solo imprimí y listo. ¡Quedó hermoso!',
    name: 'Mariana G.',
    role: '🎂 Mamá — Buenos Aires',
    emoji: '🎉'
  }, {
    quote: 'Lo estoy vendiendo en Instagram y ya hice mis primeras ventas la primera semana. El pack se paga solo.',
    name: 'Laura P.',
    role: '💰 Emprendedora — Córdoba',
    emoji: '💸'
  }, {
    quote: 'La cantidad de diseños es increíble. 26 carpetas llenas de plantillas hermosas. Mis clientas quedan encantadas.',
    name: 'Carolina M.',
    role: '🎨 Decoradora — Mendoza',
    emoji: '✨'
  }];
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-201">
        <motion.div ref={headerRef} className="text-center mb-16" initial={{
        opacity: 0,
        y: 30
      }} animate={isHeaderInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-202">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 mb-4" data-id="element-203">
            💬 Lo que dicen nuestras clientas
          </h2>
          <p className="text-xl sm:text-2xl font-bold text-rose-500" data-id="element-204">
            Ellas ya están usando el kit 🌟
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-205">
          {testimonials.map((testimonial, index) => <TestimonialCard key={testimonial.name} quote={testimonial.quote} name={testimonial.name} role={testimonial.role} emoji={testimonial.emoji} index={index} data-id="element-206" />)}
        </div>

        {/* Social proof bar */}
        <motion.div className="mt-12 flex flex-wrap justify-center gap-6 text-sm font-semibold text-slate-500" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} data-id="element-207">
          <span className="flex items-center gap-2" data-id="element-208">
            <span className="text-amber-400" data-id="element-209">★★★★★</span> 4.9/5 valoración
          </span>
          <span className="hidden sm:inline text-slate-300" data-id="element-210">·</span>
          <span data-id="element-211">📦 +500 kits vendidos</span>
          <span className="hidden sm:inline text-slate-300" data-id="element-212">·</span>
          <span data-id="element-213">💛 98% clientas satisfechas</span>
        </motion.div>
      </div>
    </section>;
}